export const CACHE_KEY_LIST_ACTIVITY_PLACE = 'activityPlaces';
export const CACHE_KEY_ACTIVITY_PLACE = 'activityPlace-one';
export const ROUTE_PATH_ACTIVITY_PLACE = '/activityplace/activity-places';
export const TRANSLATION_PREFIX_ACTIVITY_PLACE = 'activityPlace';
export const SECURITY_KEY_ACTIVITY_PLACE = 'ACTIVITY_PLACE';

export const DIALOG_ACTIVITY_PLACE_NAMESPACE = 'new-activity_place-dialog';
